<!--/**-->
<!--* 自动生成 vue列表代码【模块名：红人支付对象】-->
<!--* 生成日期：2025/11/24 19:38:23-->
<!--* 生成路径: src/pages/artist_payment/ArtistPaymentList.vue-->
<!--* 生成人：管理员-->
<!--*/-->
<template>
  <div>
    <PageHeaderLayout>
      <div class='main-page-content'>
        <div class='table-search'>
          <el-form :model='searchCondition' inline size='mini'>
            <el-form-item label='红人昵称'>
              <el-input v-model='searchCondition.nickname' placeholder='红人昵称' clearable></el-input>
            </el-form-item>
            <el-form-item label='交易平台'>
              <el-select v-model='searchCondition.platform' clearable>
                <el-option :value='0' label='银行卡'></el-option>
                <el-option :value='1' label='支付宝'></el-option>
                <el-option :value='2' label='平台充值'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label='支付对象'>
              <el-input v-model='searchCondition.name' placeholder='支付对象' clearable></el-input>
            </el-form-item>
            <el-form-item label='开户行'>
              <el-input v-model='searchCondition.open_bank' placeholder='开户行' clearable></el-input>
            </el-form-item>
            <el-form-item label='创建时间'>
              <el-date-picker
                v-model='searchCondition.date_range'
                type='daterange'
                align='right'
                unlink-panels
                range-separator='至'
                start-placeholder='开始日期'
                end-placeholder='结束日期'
                value-format='yyyy-MM-dd'
                :picker-options='pickerOptions'>
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type='primary' icon='el-icon-search' :disabled='loading' :loading='loading'
                         @click='handleQuery'>搜索
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <!--        操作栏-->
        <div class='flex-left mb8' style='padding: 8px'>
          <div>
            <el-button type='primary' icon='el-icon-plus' v-if='hasAuthority("artist_payment_create")'
                       @click='handleAdd'>新增
            </el-button>
          </div>
          <div>
            <el-button icon='el-icon-upload' v-if='hasAuthority("artist_payment_import")' @click='openImport=true'>
              导入
            </el-button>
          </div>
          <div>
            <export-btn ref='refLogisticSubscribeExport' :can-export='hasAuthority("artist_payment_export")'
                        @export='handleExport'></export-btn>
          </div>
        </div>
        <!--    渲染表格-->
        <div class='default-table'>
          <MlPageTable :all-columns='defaultColumns'
                       :table-name='tableName'
                       :data-list='dataList'
                       :limit.sync='pageData.page_size'
                       :page.sync='pageData.current_page'
                       :total.sync='total'
                       :height='height'
                       highlight-current-row
                       :row-class-name='tableRowClassName'
                       @row-click='rowClickEvent'
                       @getList='getList' border='border'>
            <template slot='tax_point'>
              <el-table-column label='票面税点' align='right' header-align='center'>
                <template slot-scope='{row}'>
                  <span class='rate'>{{ row.tax_point }}</span>
                </template>
              </el-table-column>
            </template>

            <el-table-column align='center' width='120' label='操作' fixed='right'>
              <template slot-scope='{row,$index}'>
                <el-button type='text' icon='el-icon-edit' v-if='hasAuthority("artist_payment_edit")'
                           @click='handleEdit(row)'>修改
                </el-button>
                <el-button type='text' icon='el-icon-delete' v-if='hasAuthority("artist_payment_delete")'
                           @click='handleDelete(row,$index)'>删除
                </el-button>
              </template>
            </el-table-column>
          </MlPageTable>
        </div>
      </div>

      <!-- 添加或修改对话框 -->
      <el-dialog :title='title' :visible.sync='open' width='680px' size='small' append-to-body
                 :close-on-click-modal='false'>
        <el-form ref='form' :model='form' :rules='rules' label-width='120px'>
          <el-form-item label='结算类型' prop='template_type'>
            <el-select v-model='form.template_type' clearable>
              <el-option :value='1' label='红人结算信息'></el-option>
              <el-option :value='2' label='用户结算信息'></el-option>
            </el-select>
            <!--            <el-input v-model='form.template_type' placeholder='请输入1:推广投放付款申请(绑定到红人) 2:其他付款申请(绑定到申请者)' clearable/>-->
          </el-form-item>
          <!--          <el-form-item label='申请人/红人id' prop='user_id'>-->
          <!--            <el-input v-model='form.user_id' placeholder='请输入申请人/红人id' clearable/>-->
          <!--          </el-form-item>-->
          <el-form-item label='红人昵称' prop='nickname' v-if='form.template_type===1'>
            <el-input v-model='form.nickname' placeholder='请输入红人昵称' show-word-limit maxlength='20' readonly
                      clearable>
              <el-button @click='showKolSelector' slot='append' icon='el-icon-edit'></el-button>
            </el-input>
          </el-form-item>
          <el-form-item label='用户昵称' prop='nickname' v-if='form.template_type===2'>
            <div class='flex-sb'>
              <el-input v-model='form.nickname' placeholder='请输入用户昵称'
                        show-word-limit maxlength='20'
                        readonly
                        clearable>
                <el-button @click='showSelectorUser' slot='append' icon='el-icon-edit'></el-button>
              </el-input>
              <UserSearch @selected='handleSelectedUser' v-if='isShowUserSelector' />
            </div>

          </el-form-item>
          <el-form-item label='交易平台' prop='platform'>
            <el-select v-model='form.platform' placeholder='请选择支付平台' style='width: 100%'>
              <el-option label='银行卡' :value='0'></el-option>
              <el-option label='支付宝' :value='1'></el-option>
            </el-select>
            <!--            <el-input v-model='form.platform' placeholder='请输入1: 平台充值 2:支付宝 3:银行卡' clearable/>-->
          </el-form-item>
          <el-form-item label='支付对象' prop='name'>
            <el-input v-model='form.name' placeholder='请输入支付对象' show-word-limit maxlength='50' clearable />
          </el-form-item>
          <el-form-item label='开户行' prop='open_bank'>
            <el-input v-model='form.open_bank' placeholder='请输入开户行' show-word-limit maxlength='50' clearable />
          </el-form-item>
          <el-form-item label='银行账户' prop='account'>
            <el-input v-model='form.account' placeholder='请输入银行账户' show-word-limit maxlength='50' clearable />
          </el-form-item>


          <el-form-item label='结算方式' prop='settle_method'>
            <el-select v-model='form.settle_method' placeholder='请选择结算方式' clearable
                       style='width: 100%'>
              <el-option label='对公' value='corporate' />
              <el-option label='个人' value='private' />
            </el-select>
            <!--            <el-input v-model='form.settle_method' placeholder='请输入结算方式：corporate-对公账户 private-个人账户' clearable/>-->
          </el-form-item>
          <el-form-item label='票面税点（%）' prop='tax_point'>
            <el-select v-model='form.tax_point' filterable allow-create placeholder='请选择票面税点' clearable
                       style='width: 100%'>
              <el-option label='1' value='1.00' />
              <el-option label='3' value='3.00' />
              <el-option label='6' value='6.00' />
            </el-select>
            <!--            <el-input v-model='form.tax_point' placeholder='请输入票面税点' clearable/>-->
          </el-form-item>
          <el-form-item label='发票类型' prop='invoice_type'>
            <el-select v-model='form.invoice_type' placeholder='请选择发票类型' clearable
                       style='width: 100%'>
              <el-option label='普通发票' value='normal' />
              <el-option label='专用发票' value='special' />
            </el-select>
            <!--            <el-input v-model='form.invoice_type' placeholder='请输入发票类型' clearable/>-->
          </el-form-item>

        </el-form>
        <div slot='footer' class='dialog-footer'>
          <el-button type='primary' @click='submitForm' :disabled='loadingCommit' :loading='loadingCommit'>确 定
          </el-button>
          <el-button @click='cancel'>取 消</el-button>
        </div>
      </el-dialog>
      <!--      导入-->
      <ImportArtistPayment :visible.sync='openImport' v-if='hasAuthority("artist_payment_import")'
                           @imported='handleQuery' />
      <!--      选择红人-->
      <ArtistSelector ref='refArtistSelector' @handleSelected='handleSelectedKol' />
    </PageHeaderLayout>
  </div>
</template>

<script>
import MlPageTable from '@/components/common/MlPageTable'
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ExportBtn from '@/components/export/ExportBtn'
import ImportArtistPayment from './ImportArtistPayment'
import {
  deleteArtistPayment,
  exportArtistPayments,
  getArtistPaymentInfo,
  getArtistPaymentList,
  saveArtistPayment
} from '@/api/artist_payment'
import ArtistSelector from '@/components/artist/ArtistSelector.vue'
import UserSearch from '@/pages/user/components/UserSearch.vue'

export default {
  name: 'ArtistPaymentList',
  components: {
    UserSearch,
    ArtistSelector,
    ImportArtistPayment,
    ExportBtn,
    PageHeaderLayout,
    MlPageTable
  },
  data() {
    return {
      tableName: 'artist_payment',
      loading: false,
      loadingCommit: false,
      dataList: [],
      total: 0,
      height: 800,
      searchCondition: {
        date_range: [],
        user_id: null,
        nickname: null,
        name: null,
        open_bank: null,
        account: null,
        template_type: null,
        platform: null,
        settle_method: null,
        tax_point: null,
        invoice_type: null
      },
      pageData: { current_page: 1, page_size: 15 },
      orderBy: { id: 'desc' },
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      defaultColumns: [{ hide: false, prop: 'id', label: '序号', width: 80, sortable: false, fixed: true },
        // { hide: false, prop: 'user_id', label: '申请人/红人id', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'nickname', label: '申请人/红人', width: 160, sortable: true, fixed: true },
        { hide: false, prop: 'pay_platform', label: '交易平台', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'name', label: '支付对象', width: 120, sortable: true, fixed: false },
        { hide: false, prop: 'open_bank', label: '开户行', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'account', label: '银行账户', width: 220, sortable: false, fixed: false },
        { hide: false, prop: 'template_type_text', label: '结算信息类型', width: 120, sortable: false, fixed: false },
        // { hide: false, prop: 'template_type', label: '1:推广投放付款申请(绑定到红人) 2:其他付款申请(绑定到申请者)', width: 120, sortable: false, fixed: false },
        // { hide: false, prop: 'platform', label: '交易平台', width: 120, sortable: false, fixed: false },

        { hide: false, prop: 'settle_method_text', label: '结算方式', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'tax_point', label: '票面税点', width: 120, sortable: false, fixed: false, slot: true },
        { hide: false, prop: 'invoice_type_text', label: '发票类型', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'created_at', label: '创建时间', width: 120, sortable: true, fixed: false },
        { hide: false, prop: 'updated_at', label: '修改时间', width: 120, sortable: true, fixed: false }
      ],

      // 弹出层标题
      title: '添加/修改-红人支付对象',
      // 是否显示弹出层
      open: false,
      // 表单校验
      rules: {
        user_id: [{ required: true, message: '申请人/红人id不能为空', trigger: 'blur' }],
        nickname: [{ required: true, message: '红人昵称不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '支付对象不能为空', trigger: 'blur' }],
        open_bank: [{ required: true, message: '开户行不能为空', trigger: 'blur' }],
        account: [{ required: true, message: '银行账户不能为空', trigger: 'blur' }],
        template_type: [{ required: true, message: '申请类型不能为空', trigger: 'blur' }],
        platform: [{ required: true, message: '平台交易不能为空', trigger: 'blur' }],
        settle_method: [{ required: true, message: '结算方式', trigger: 'blur' }],
        tax_point: [{ required: true, message: '票面税点不能为空', trigger: 'blur' }],
        invoice_type: [{ required: true, message: '发票类型不能为空', trigger: 'blur' }]
      },
      // 表单参数
      form: {
        id: null,
        user_id: '',
        nickname: '',
        name: '',
        open_bank: '',
        account: '',
        template_type: 1,
        platform: '',
        settle_method: '',
        tax_point: 0,
        invoice_type: ''
      },
      //是否显示弹出层:导入框
      openImport: false,
      //筛选条件缓存key
      pageSearchKey: 'page_search_key:artist_payment',
      employeesVisible: false,
      isShowUserSelector: false
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    rowClickEvent(row, column, event) {
      // this.$notify.info(`数据ID：${row.id}`)
    },
    // eslint-disable-next-line no-unused-vars
    tableRowClassName({ row, rowIndex }) {
      return 'default-table-row'
    },
    handleSearchCondition() {
      const condition = {}
      Object.keys(this.searchCondition).forEach((field) => {
        if (this.searchCondition[field] != null) {
          condition[field] = this.searchCondition[field]
        }
      })

      // 分页 +排序
      Object.assign(condition, this.pageData, { orderBy: this.orderBy })

      return condition
    },
    handleQuery() {
      this.pageData.current_page = 1
      this.getList()
      //缓存筛选条件，刷新后可以继续使用
      sessionStorage.setItem(this.pageSearchKey, JSON.stringify(this.searchCondition))
    },
    async getList() {
      this.dataList = []
      this.loading = true
      const params = this.handleSearchCondition()
      const { list, pages } = await getArtistPaymentList(params)
      // this.dataList = [...this.dataList, ...list]
      this.dataList = list
      this.pageData.current_page = pages.current_page || 1
      this.pageData.page_size = pages.page_size || 100
      this.total = pages.total
      this.loading = false
    },
    /** 删除按钮 */
    handleDelete(row, index) {
      if (row.id) {
        //真实删除
        this.$confirm('此操作将删除该行数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delRow(row.id)
          this.dataList.splice(index, 1)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      } else {
        this.tableData.splice(index, 1)
      }
    },
    async delRow(id) {
      await deleteArtistPayment(id)
    },
    /** 修改按钮 */
    handleAdd() {
      this.open = true
      this.title = '添加-红人支付对象'
      this.form = {
        id: null,
        user_id: '',
        nickname: '',
        name: '',
        open_bank: '',
        account: '',
        template_type: 1,
        platform: '',
        settle_method: '',
        tax_point: 0,
        invoice_type: ''
      }
    },
    /** 修改按钮 */
    async handleEdit(row) {
      this.open = true
      this.title = '修改-红人支付对象'
      const { info } = await getArtistPaymentInfo(row.id)
      this.form = { ...info }
    },

    /** 提交按钮 */
    async submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loadingCommit = true
          saveArtistPayment(this.form).then(id => {
            if (id) {
              if (!this.form.id)
                this.msgSuccess('新增成功')
              else
                this.msgSuccess('修改成功')

              this.form.id = id
              this.open = false
              this.getList()
            } else {
              this.msgError('操作失败')
            }
            setTimeout(() => {
              this.loadingCommit = false
            }, 500)
          })

        }
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.form = {}
    },
    //导出表格
    async handleExport() {
      try {
        const searchCondition = this.handleSearchCondition()
        const response = await exportArtistPayments(searchCondition)
        const name = `红人支付对象`

        this.$refs.refLogisticSubscribeExport.exportSaveXlsx(response, name)
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
        // alert(JSON.stringify(e))
        this.$refs.refLogisticSubscribeExport.hideLoading()
      }
    },
    showKolSelector() {
      if (this.$refs['refArtistSelector'])
        this.$refs['refArtistSelector'].handleOpen()
    },
    handleSelectedKol(item) {
      // console.log(item)
      this.form.user_id = item.artist_id
      this.form.nickname = item.nickname
    },
    showSelectorUser() {
      this.isShowUserSelector = !this.isShowUserSelector
    },
    handleSelectedUser(item) {
      // console.log(item)
      this.form.user_id = item.id
      this.form.nickname = item.nickname
      this.isShowUserSelector = false
    }
  },
  created() {
    if (sessionStorage.getItem(this.pageSearchKey)) {
      this.searchCondition = JSON.parse(sessionStorage.getItem(this.pageSearchKey))
    }
    this.handleQuery()
  }
}
</script>

<style scoped>
.table-search {
  //padding-top: 5px;
  //margin-bottom: 5px;
}

</style>
